module.exports = [
  "$scope",
  function($scope) {
    // ------------------
    // scope functions
    // ------------------
    $scope.togglePasswordGenerator = function() {
      $scope.generatePassword = !$scope.generatePassword;
    };
    $scope.submit = function($event) {
      if(!$scope.idAcceptCheckbox) {
        $scope.acceptCheckboxError = true;
        $event.preventDefault();
      }
    };
    $scope.acceptCheckboxChange = function() {
      if($scope.idAcceptCheckbox) {
        $scope.acceptCheckboxError = false;
      }
    };
    $scope.generatePassword = true;
    $scope.idAcceptCheckbox = false;
    $scope.acceptCheckboxError = false;
  }
];
